import React from 'react';
import { Divider, message } from '@fuxi/eevee-ui';
import { useTranslation } from 'react-i18next';
import {
  LoginType,
  isBaidu,
  isPOPO,
  isPc,
  isQQ,
  isQQBrowser,
  isUC,
  isWechat,
  loginByGoogle,
  loginByWechat,
  loginByWechatMobile,
} from '@yaotai/common-utils';

import { Oem, useLoginType, useMatchAid } from '../../hooks';
import { LoginTypeEnum } from '../../constants';
import { ThirdLoginLayout } from './styles';

export const ThirdLogin = ({
  rbacUrl,
  overseaRbacUrl,
  wechatLogo,
  googleLogo,
  jumpUrl,
  style = {},
  portHost,
  rbac_server,
  wechatUrl,
  otherLogo,
  className,
  oem,
}: {
  className?: string;
  googleLogo: string;
  jumpUrl?: string;
  otherLogo: string;
  overseaRbacUrl: string;
  portHost: string;
  rbac_server: string;
  rbacUrl: string;
  style?: React.CSSProperties;
  wechatLogo: string;
  wechatUrl?: string;
  oem?: Oem;
}) => {
  const hasWechatLogin = isPc || isWechat;
  const hasGoogleLogin = !isWechat && !isBaidu && !isUC && !isQQ && !isQQBrowser && !isPOPO;
  const { hasAid, hasSid } = useMatchAid();
  const isMain = !hasAid && !hasSid;

  const loginAccessibleCount = Number(hasWechatLogin) + Number(hasGoogleLogin);
  const hasOtherLogin = oem?.oem_log_email?.status || oem?.oem_log_wechat?.status || oem?.oem_log_google?.status;
  const phoneType = JSON.parse(oem?.oem_log_email?.detail || '{}')?.type || LoginTypeEnum.URS;

  const { setLoginType } = useLoginType();
  const { t } = useTranslation();

  return (
    <ThirdLoginLayout style={style} className={className}>
      {loginAccessibleCount > 0 && hasOtherLogin && (
        <Divider className={'divider'}>
          <span>{t('login.or')}</span>
        </Divider>
      )}
      <div className={'third-login-wrapper'}>
        {((oem?.oem_log_email?.status && phoneType === LoginTypeEnum.URS) || isMain) && (
          <div className="third-logo-parent">
            <img
              className={'third-logo'}
              src={otherLogo}
              onClick={() => {
                setLoginType(LoginType.NetEaseMail);
              }}
              alt=""
            />
            <p>{t('login.EmailLogin')}</p>
          </div>
        )}
        {oem?.oem_log_email?.status && phoneType === LoginTypeEnum.RBAC && (
          <div className="third-logo-parent">
            <img
              className={'third-logo'}
              src={otherLogo}
              onClick={() => {
                setLoginType(LoginType.CommonMail);
              }}
              alt=""
            />
            <p>{t('login.EmailLogin')}</p>
          </div>
        )}
        {hasWechatLogin && (oem?.oem_log_wechat?.status || isMain) && (
          <div className="third-logo-parent">
            <img
              onClick={() => {
                if (isWechat) {
                  loginByWechatMobile({
                    rbacUrl: 'https://rbac.fuxi.netease.com',
                    url: jumpUrl,
                    portHost,
                    wechatUrl,
                  });
                  return;
                }
                if (!isPc) {
                  message.error('暂不支持移动端登录');
                  return;
                }
                loginByWechat({
                  rbacUrl,
                  url: jumpUrl,
                  rbac_server,
                });
              }}
              className={'third-logo'}
              src={wechatLogo}
              alt=""
            />
            <p>{t('login.WeChat')}</p>
          </div>
        )}

        {hasGoogleLogin && (oem?.oem_log_google?.status || isMain) && (
          <div className="third-logo-parent">
            <img
              className={'third-logo'}
              onClick={() => {
                loginByGoogle({
                  rbacUrl: overseaRbacUrl,
                  url: jumpUrl,
                  rbac_server,
                });
              }}
              src={googleLogo}
              alt=""
            />
            <p>{t('login.Google')}</p>
          </div>
        )}
      </div>
    </ThirdLoginLayout>
  );
};
